module.exports = __webpack_public_path__ + "img/gh-30282-1-86.prt.27055de8.jpg";